import {
  Divider,
  Link,
  List,
  ListItem,
  ListItemText,
  Paper,
  Tabs,
  Tab,
  Chip,
  Grid,
  Collapse,
  RadioGroup,
  FormLabel,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import "date-fns";
import "fontsource-roboto";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import {
  reqCategorys,
  reqMstCodes,
  reqSearchJC,
  reqSetHotInfo,
  reqGetHotInfo,
  reqSearchSu,
  reqGetAllInfo,
  reqGetNewsInfo,
  reqGetFilesInfo,
  reqGetKbInfo,
  reqGetFwInfo,
} from "../utils/apis";
import {
  getLocations,
  getQueryVariable,
  encodePacent,
} from "../utils/utilTools";
import SearchTool from "./search-tool";
import SearchAll from "./search-all";
import SearchDialog from "./search-dialog";
import SearchNews from "./search-news";
import SearchFiles from "./search-files";
import SearchKb from "./search-kb";
import SearchService from "./search-service";
import SearchDialogFiles from "./search-dialog-files";
import {
  PinDrop,
  Announcement,
  FileCopy,
  LiveHelp,
  HeadsetMic,
  Home,
} from "@material-ui/icons";
import cookie from "react-cookies";
import $ from "jquery";

require("../assets/css/style.css");
require("../assets/css/files-style.css");

const useStyles = {
  root: {
    "& > *": {
      width: "65ch",
      color: "#333",
    },
  },
  inputText: {
    textAlign: "center",
    width: "97px",
    padding: "0 5px 0 0 !important",
    height: "26px",
    "& .MuiOutlinedInput-root .MuiOutlinedInput-inputMarginDense": {
      paddingTop: "3px",
      paddingBottom: "3px",
    },
  },
  breakLine: {
    margin: "20px 0 0 0",
  },
  breakLineInset: {
    margin: "20px 0 0 16px",
  },
};

const defaultgjss = {
  sssz: "1",
  sscwz: "1",
  category: "1",
  fwValues: "1",
  sjfw: "0",
  sjfw_from: "",
  sjfw_to: "",
  order: "1",
  zdfw: "0",
  pageSize: "10",
};
const defaultzwgk = {
  organization: "1", // 发布机构
  year: "", //发布年份
  filenumberPre: "", // 发文字号前缀
  filenumber: "", // 发文字号
  group: "0", // 公文种类
  cwrq_from: "", //成文日期
  cwrq_to: "", //成文日期
};

const ZQ_WEBSITE_IDS = [
  "00e81f9888f249a7aad5ed12130d3189",
  "091ab5ed6b9c453fa2d133a75ecc9151",
  "0ee08c6f88aa4cf68b31233a49680f39",
  "12266105d7a04b0d8596ed1f6367b83c",
  "143fd1aa576a402f9dec5816902017fb",
  "24fe0f9b9a8345069f865d8be216124c",
  "3affcebd7bd4456ea6604fd7e74a42d9",
  "49346bd6c66145f1a6b2f1af65a6cc7f",
  "5c1138e35e094204a4e863ca488a2d5a",
  "668fcafc54254fe7bf9dd957e83cc2c9",
  "716b28fe23164750ac862fa246f156cb",
  "915e864e3dea47019b1baeb9c3ccc68d",
  "94c8d13e0bec4efdb973593dfb53eb74",
  "a23013330ae049e6b9b3187760aa69f7",
  "a3cf037bd4b84bcba7a266f5344d457b",
  "a8607699335845bb9892efc9bd27e1ef",
  "ab9006439df54c428ea84582f61eddf3",
  "aca538a8df17461e8a8778d05b2c5c93",
  "af9df6a04d534d768b43f43881e2017f",
  "c19b4d61e90e491a88b93e145f989e45",
  "d9205e7ff2764fe69e96d66bbbeb55fe",
  "de1151ba055844ab8246154b0edf8954",
  "e3c24cc255b64c89b1e1721bd8b4d30b",
  "e4f0e8a733e34ed28f0620789e66a128",
  "e96d0073d2d14c6ea1217478fceddd85",
  "e9dd07487cbd44e68ac7164f59c189c8",
  "ea3f450b9aa54b9899b283656bae1888",
  "f2a7de7fd3a04bd3a873e35dc099a0bf",
  "f2e084ac6377448aad4c4f3af0bda3cf",
  "f43d0fc535b14a0c90b5730d63cd8721",
  "fc4292fddec04f63b276a9808aaae296",
  "fe3eb0b722b7432ea5d06c949c45cdba",
  "fe9a0be09fde4df6a7488a492ee250cc",
  "e303449473eb42198cb4692fd42c3a15",
  "9e6365fd9072460da5320d31dc9f14a9",
  "569012ebb4b9462a9f6c633227a8ef5b",
  "d97020fe6c6543a19bdadeae39ad4d54",
  "6f2146312e324f9e98099f52002f10eb",
  "5f26120115824722ba2229d0ceaa65b2",
];

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

class SearchResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showContent: false,
      randomColor: 1,
      websiteid: "",
      keyword: "",
      cuskeyword: "",
      reqparam: {},
      showList: [],
      listIndex: 0,
      openCustom: false,
      openScope: false,
      selectedDate: new Date(),
      showWenhaoCon: false,
      tabValue: 0,
      pageSize: 10,
      file_pageSize: 10,
      kb_pageSize: 10,
      fw_pageSize: 10,
      pageNum: 1,
      file_pageNum: 1,
      kb_pageNum: 1,
      fw_pageNum: 1,
      iszwgk: false,
      gjss: {
        sssz: "1",
        sscwz: "1",
        category: "1",
        fwValues: "1",
        sjfw: "0",
        sjfw_from: "",
        sjfw_to: "",
        order: "1",
        zdfw: "0",
        pageSize: "10",
      },
      zwgk: {
        organization: "1", // 发布机构
        year: "", //发布年份
        filenumberPre: "", // 发文字号前缀
        filenumber: "", // 发文字号
        group: "0", // 公文种类
        cwrq_from: "", //成文日期
        cwrq_to: "", //成文日期
      },
      totalcount: 0,
      results: [],
      file_results: [],
      file_totalcount: 0,
      file_pages: 0,
      kb_results: [],
      kb_totalcount: 0,
      kb_pages: 0,
      fw_results: [],
      fw_totalcount: 0,
      fw_pages: 0,
      showLoading: false,
      file_showLoading: false,
      kb_showLoading: false,
      fw_showLoading: false,
      pages: 0,
      hotWords: [],
      hotInfos: [],
      fileSearchType: 0,
      isMobile: false,
      init: true,
      all_pageSize: 10,
      all_pageNum: 1,
      allResult: [],
      all_totalcount: 0,
      all_pages: 0,
      all_showLoading: false,
      userId: "",
      nojc: 0,
      originalKeyword: "",
      correctedKeyword: "",
      isInZd: true,
      xw_juhe: [],
      hd_juhe: [],
      fw_juhe: [],
      isGh: false,
      searchType: "0",
    };
  }

  pregjss = defaultgjss;
  prezwgk = defaultzwgk;

  IsPC = () => {
    var userAgentInfo = navigator.userAgent.toLowerCase();

    var Agents = [
      "android",
      "iphone",
      "symbianos",
      "windows phone",
      "ipad",
      "ipod",
    ];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) >= 0) {
        flag = false;
        break;
      }
    }
    return flag;
  };

  componentDidCatch(error, errorInfo) {
    console.log("==============", error, errorInfo);
  }

  componentWillUnmount = () => {
    this.setState = (state, callback) => {
      return;
    };
  };

  componentWillMount() {
    this.setState(
      {
        keyword: getQueryVariable("wd"),
        websiteid: getQueryVariable("websiteid"),
        iszwgk: Number(getQueryVariable("zwgk")) === 1,
        isInZd: Number(getQueryVariable("isGroup")) !== 1, // 本站或站群
        tabValue: ZQ_WEBSITE_IDS.includes(getQueryVariable("websiteid"))
          ? 0
          : 1,
        userId: cookie.load("tzinterface_encryptKey")
          ? cookie.load("tzinterface_encryptKey")
          : "",
      },
      () => {
        this.handleZdSearch(this.state.isInZd);
      }
    );
  }

  componentDidMount() {
    reqMstCodes(null, (res) => {
      const appids = [];
      res.data.data.zdfw.forEach((item) => {
        appids.push(item.value);
      });
      const params = {
        appid: "3", // 数组转换成string
      };
      this.setState({
        gjss: {
          sssz: "1",
          sscwz: "1",
          category: "1",
          fwValues: "1",
          sjfw: "0",
          sjfw_from: "",
          sjfw_to: "",
          order: "1",
          zdfw: "0",
          pageSize: "10",
          fwOptions: res.data.data,
        },
        init: false,
        isGh: document
          .getElementsByTagName("body")[0]
          .classList.contains("old_type"),
      });

      reqCategorys(params, (res) => {
        if (res.data.code === "100") {
          return;
        }
        this.setState({
          zwgk: {
            organization: "1", // 发布机构
            year: "", //发布年份
            filenumberPre: "", // 机关代字
            filenumber: "", // 发文字号
            group: "0", // 公文种类
            cwrq_from: "", //成文日期
            cwrq_to: "", //成文日期
            organizations: res.data.data.organizations,
            years: res.data.data.promulgationtimes,
            filenumbers: res.data.data.filenumbers,
            groups: res.data.data.groups,
          },
        });
      });
    });
    reqGetHotInfo(null, (res) => {
      if (res.data.code === "100") {
        return;
      }
      this.setState({
        hotWords: [
          { keyword: "两会" },
          { keyword: "政府工作报告" },
          { keyword: "证件办理" },
          { keyword: "泰州新闻" },
          { keyword: "政务公开" },
          { keyword: "民生问题" },
        ],
        hotInfos: res.data.data.hotInfos,
      });
    });

    window.addEventListener("click", this.handleClick.bind(this));
    if (!this.IsPC()) {
      this.setState({
        isMobile: true,
      });
    }
  }

  //锚点跳转
  scrollToAnchor = (anchorName) => {
    if (anchorName) {
      // 找到锚点
      let anchorElement = document.getElementById(anchorName);
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        anchorElement.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    }
  };

  handleClick(e) {
    // if (this.state.showList.length === 0) {
    //   return;
    // }
    if (e.target !== document.getElementsByClassName("intTxt bt-left")[0]) {
      this.setState({
        showList: [],
      });
    }
  }

  //处理输入
  handleInput = (ev) => {
    var _this = this;
    // if (!ev.target.value || ev.target.value === "") {
    //   _this.setState({
    //     keyword: ev.target.value,
    //     showList: [],
    //   });
    //   return;
    // }
    _this.setState(
      {
        keyword: ev.target.value,
      },
      function () {
        let list = [];

        const param = {
          keyword: _this.state.keyword,
          userId: _this.state.userId,
          websiteid: _this.state.websiteid,
        };
        reqSearchSu(param, (res) => {
          if (res.data && res.data.data) {
            res.data.data.forEach((item) => {
              list.push(item);
            });

            _this.setState({
              showList: list,
            });
          }
        });
      }
    );
  };

  //处理鼠标hover
  handleMouseSelect(ev) {
    var index = ev.target.getAttribute("data-index");
    this.setState({
      listIndex: parseInt(index),
    });
  }

  //处理点击列表
  handleSelectClick(ev) {
    this.setState(
      {
        keyword: ev.target.innerText,
        showList: [],
      },
      function () {
        this.refs.input.value = this.state.keyword;
        setTimeout(() => {
          this.handleSearch();
        }, 50);
      }
    );
  }

  //处理点击清除按钮
  handleClearClick() {
    this.setState({
      keyword: "",
      showList: [],
    });
    this.refs.input.value = "";
  }

  //点击搜索按钮
  handleZdSearch() {
    if (this.state.searchType !== "0") {
      const keyword = this.state.keyword;
      this.setState({
        cuskeyword: decodeURIComponent(encodePacent(keyword))
      }, () => {
        this.handleSearchClick();
      })
      return;
    }
    // 修改url
    window.history.pushState(
      null,
      null,
      window.location.href.split("?")[0] +
        "?wd=" +
        this.state.keyword +
        "&websiteid=" +
        this.state.websiteid +
        "&isGroup=" +
        (this.state.isInZd ? 0 : 1) +
        "&zwgk=" +
        (this.state.iszwgk ? 1 : 0)
    );

    var _state = this.state;
    if (_state.iszwgk) {
      this.setState({
        tabValue: 2,
      });
    }
    let sh = localStorage.getItem("searchHistory");
    let k = decodeURIComponent(encodePacent(_state.keyword));
    k = k.replace(/^\s+|\s+$/g, "");
    let dk = JSON.stringify(k);

    if (k && k.length > 0) {
      // 本地搜索历史
      if (!sh) {
        sh = new Array();
        sh.unshift(k);
        localStorage.setItem("searchHistory", JSON.stringify(sh));
      } else if (sh && sh.indexOf(dk) < 0) {
        sh = JSON.parse(sh);
        sh.unshift(k);
        localStorage.setItem("searchHistory", JSON.stringify(sh));
      } else if (sh.indexOf(dk) > 0) {
        sh = JSON.parse(sh);
        sh.splice(sh.indexOf(k), 1);
        sh.unshift(k);
        localStorage.setItem("searchHistory", JSON.stringify(sh));
      }
      this.setState({
        showLoading: true,
        openCustom: false,
        showList: [],
      });
    }
    var param = JSON.parse(JSON.stringify(defaultgjss)); // 深copy
    delete param.fwOptions;

    // param.category = _state.tabValue.toString();
    if (param.category === "2") {
      // for (var index in _state.zwgk) {
      //   param[index] = _state.zwgk[index];
      // }
      for (var index in defaultzwgk) {
        param[index] = defaultzwgk[index];
      }
      delete param.organizations;
      delete param.years;
      delete param.filenumbers;
      delete param.groups;
    }

    if (_state.isInZd) {
      param["zdfw"] = _state.websiteid;
    }
    param["keyword"] = decodeURIComponent(encodePacent(_state.keyword));
    param["pageSize"] = _state.pageSize;
    param["pageNum"] = 1;
    param["kb_pageNum"] = 1;
    param["file_pageNum"] = 1;
    param["fw_pageNum"] = 1;
    param["all_pageNum"] = 1;
    param["fileSearchType"] = _state.fileSearchType;

    param["userId"] = _state.userId;
    param["nojc"] = 0;
    param["originalKeyword"] = _state.originalKeyword;
    param["correctedKeyword"] = _state.correctedKeyword;
    param["websiteid"] = _state.websiteid;

    this.setState(
      {
        reqparam: param,
        pageNum: 1,
        file_pageNum: 1,
        kb_pageNum: 1,
        fw_pageNum: 1,
        all_pageNum: 1,
        nojc: 0,
      },
      () => {
        this.handleSearchJC();
      }
    );
  }

  handleSearchJC() {
    reqSearchJC(this.state.reqparam, (res) => {
      if (res.data) {
        let param = this.state.reqparam;
        param["originalKeyword"] = res.data.originalKeyword;
        param["correctedKeyword"] = res.data.correctedKeyword;
        this.setState(
          {
            originalKeyword: res.data.originalKeyword,
            correctedKeyword: res.data.correctedKeyword,
            reqparam: param,
          },
          () => {
            this.handleAllSearch();
            this.handleSearch();
            this.handleFileSearch();
            this.handleKbSearch();
            this.handleFwSearch();
          }
        );
      }
    });
  }

  // 点击精确搜索按钮
  handleSearchClick() {
    // 修改url
    window.history.pushState(
      null,
      null,
      window.location.href.split("?")[0] +
        "?wd=" +
        this.state.keyword +
        "&websiteid=" +
        this.state.websiteid +
        "&isGroup=" +
        (this.state.isInZd ? 0 : 1) +
        "&zwgk=" +
        (this.state.iszwgk ? 1 : 0)
    );
    var _state = this.state;
    let sh = localStorage.getItem("searchHistory");
    let k = decodeURIComponent(encodePacent(_state.cuskeyword));
    k = k.replace(/^\s+|\s+$/g, "");
    let dk = JSON.stringify(k);

    if (k && k.length > 0) {
      // 本地搜索历史
      if (!sh) {
        sh = new Array();
        sh.unshift(k);
        localStorage.setItem("searchHistory", JSON.stringify(sh));
      } else if (sh && sh.indexOf(dk) < 0) {
        sh = JSON.parse(sh);
        sh.unshift(k);
        localStorage.setItem("searchHistory", JSON.stringify(sh));
      } else if (sh.indexOf(dk) > 0) {
        sh = JSON.parse(sh);
        sh.splice(sh.indexOf(k), 1);
        sh.unshift(k);
        localStorage.setItem("searchHistory", JSON.stringify(sh));
      }
    }
    this.setState({
      showLoading: true,
      openCustom: false,
      showList: [],
    });

    var param = JSON.parse(JSON.stringify(_state.gjss)); // 深copy
    delete param.fwOptions;

    param.category = _state.tabValue.toString();
    if (param.category === "2") {
      for (var index in _state.zwgk) {
        param[index] = _state.zwgk[index];
      }
      delete param.organizations;
      delete param.years;
      delete param.filenumbers;
      delete param.groups;
    }

    param["keyword"] = decodeURIComponent(encodePacent(_state.cuskeyword));
    param["pageSize"] = _state.pageSize;
    param["pageNum"] = 1;
    param["kb_pageNum"] = 1;
    param["file_pageNum"] = 1;
    param["fw_pageNum"] = 1;
    param["all_pageNum"] = 1;
    param["fileSearchType"] = _state.fileSearchType;

    param["originalKeyword"] = _state.originalKeyword;
    param["correctedKeyword"] = _state.correctedKeyword;
    param["websiteid"] = _state.websiteid;

    this.setState(
      {
        reqparam: param,
        pageNum: 1,
        file_pageNum: 1,
        kb_pageNum: 1,
        fw_pageNum: 1,
        all_pageNum: 1,
      },
      () => {
        this.handleSearchJC();
      }
    );
  }

  // 搜索全部
  handleAllSearch() {
    var parm = this.state.reqparam;
    parm.pageSize = this.state.all_pageSize;
    this.setState({
      all_showLoading: true,
    });
    reqGetAllInfo(this.state.reqparam, (res) => {
      // console.log(res);
      if (res.data && res.data.data) {
        this.setState({
          showContent: true,
          allResult: res.data.data,
          all_totalcount: res.data.count,
          all_showLoading: false,
          all_pages:
            res.data.count % this.state.all_pageSize > 0
              ? parseInt(res.data.count / this.state.all_pageSize) + 1
              : res.data.count / this.state.all_pageSize,
        });
      }

      // 缩小顶部搜索域
      // document
      //   .getElementsByClassName("logo")[0]
      //   .getElementsByTagName("img")[0].style.marginLeft = "-960px";
      // document
      //   .getElementsByClassName("logo")[0]
      //   .getElementsByTagName("img")[0].style.width = "250px";

      document.getElementsByClassName("search clearfix")[0].style.top = "-60px";
      // document.getElementsByClassName("hotSearch clearfix")[0].style.top =
      //     "-173px";
      document.getElementsByClassName("searchType clearfix")[0].style.top =
        "-50px";
      document.getElementsByClassName("content-body")[0].style.top = "-30px";

      // setTimeout(() => {
      //   let containerElement =
      //       document.getElementsByClassName("main-container")[0];
      //   let contentElement = document.getElementsByClassName("content-body")[0];
      //   if (this.state.isGh) {
      //     containerElement.style.height = contentElement.clientHeight + 87 + "px";
      //   } else {
      //     containerElement.style.height = contentElement.clientHeight - 53 + "px";
      //   }
      // }, 20);
    });
  }

  //处理搜索
  handleSearch() {
    var parm = this.state.reqparam;
    parm.pageSize = this.state.pageSize;
    this.setState({
      showLoading: true,
    });
    reqGetNewsInfo(this.state.reqparam, (res) => {
      // console.log(res);
      if (res.data && res.data.data) {
        this.setState({
          showContent: true,
          results: res.data.data,
          totalcount: res.data.count,
          showLoading: false,
          pages:
            res.data.count % this.state.pageSize > 0
              ? parseInt(res.data.count / this.state.pageSize) + 1
              : res.data.count / this.state.pageSize,
          xw_juhe:
            this.state.pageNum === 1 ? res.data.data : this.state.xw_juhe,
        });
      }
    });
  }

  handleFileSearch() {
    var parm = this.state.reqparam;
    parm.pageSize = this.state.file_pageSize;
    this.setState({
      file_showLoading: true,
    });
    reqGetFilesInfo(parm, (res) => {
      if (res.data && res.data.data) {
        this.setState({
          showContent: true,
          file_results: res.data.data,
          file_totalcount: res.data.count,
          file_showLoading: false,
          file_pages:
            res.data.count % this.state.file_pageSize > 0
              ? parseInt(res.data.count / this.state.file_pageSize) + 1
              : res.data.count / this.state.file_pageSize,
        });
      }
      // if (this.state.gjss.category === "2") {
      //   this.scrollToAnchor("fileAnchor");
      // }
    });
  }

  handleKbSearch() {
    var parm = this.state.reqparam;
    parm.pageSize = this.state.kb_pageSize;
    this.setState({
      kb_showLoading: true,
    });
    reqGetKbInfo(JSON.stringify(parm), (res) => {
      if (res.data && res.data.data) {
        this.setState({
          showContent: true,
          kb_results: res.data.data,
          kb_totalcount: res.data.count,
          kb_showLoading: false,
          kb_pages:
            res.data.count % this.state.kb_pageSize > 0
              ? parseInt(res.data.count / this.state.kb_pageSize) + 1
              : res.data.count / this.state.kb_pageSize,
          hd_juhe:
            this.state.kb_pageNum === 1 ? res.data.data : this.state.hd_juhe,
        });
      }
    });
  }

  handleFwSearch() {
    var parm = this.state.reqparam;
    parm.pageSize = this.state.fw_pageSize;
    this.setState({
      fw_showLoading: true,
    });
    reqGetFwInfo(JSON.stringify(parm), (res) => {
      if (res.data && res.data.data) {
        this.setState({
          showContent: true,
          fw_results: res.data.data,
          fw_totalcount: res.data.count,
          fw_showLoading: false,
          fw_pages:
            res.data.count % this.state.fw_pageSize > 0
              ? parseInt(res.data.count / this.state.fw_pageSize) + 1
              : res.data.count / this.state.fw_pageSize,
          fw_juhe:
            this.state.fw_pageNum === 1 ? res.data.data : this.state.fw_juhe,
        });
      }
      // setTimeout(() => {
      //   let containerElement =
      //       document.getElementsByClassName("main-container")[0];
      //   let contentElement = document.getElementsByClassName("content-body")[0];
      //   if (this.state.isGh) {
      //     containerElement.style.height = contentElement.clientHeight + 87 + "px";
      //   } else {
      //     containerElement.style.height = contentElement.clientHeight - 53 + "px";
      //   }
      // }, 20);
    });
  }

  //处理Enter键
  handleKeyEnter(ev) {
    var keyCode = ev.keyCode;

    switch (keyCode) {
      case 13:
        this.setState(
          {
            fileSearchType: 0,
            pageNum: 1,
            file_pageNum: 1,
            kb_pageNum: 1,
            fw_pageNum: 1,
            all_pageNum: 1,
          },
          () => {
            this.handleZdSearch(this.state.isInZd);
            // this.handleFileSearch();
            // this.handleKbSearch();
          }
        );
        break;
      case 27:
        this.setState({
          showList: [],
        });
        break;
      case 38:
        this.selectUpAndDown(ev, keyCode);
        break;
      case 40:
        this.selectUpAndDown(ev, keyCode);
        break;
      default:
        break;
    }
  }

  //上下键选择列表项
  selectUpAndDown(ev, keycode) {
    if (this.state.showList.length === 0) {
      return;
    }
    ev.preventDefault();
    var _state = this.state;

    var stateCb = function () {
      let word = this.state.showList[this.state.listIndex].replace(/<em>/g, "");
      word = word.replace(/<\/em>/g, "");
      this.setState(
        {
          keyword: word,
        },
        function () {
          this.refs.input.value = this.state.keyword;
        }
      );
    };

    if (keycode === 38) {
      this.setState(
        {
          listIndex: _state.listIndex == 0 ? 9 : --_state.listIndex,
        },
        stateCb
      );
    } else if (keycode === 40) {
      this.setState(
        {
          listIndex:
            _state.listIndex == _state.showList.length - 1
              ? 0
              : ++_state.listIndex,
        },
        stateCb
      );
    }
  }

  handleDateChange(ev) {
    this.setState({
      selectedDate: ev,
    });
  }

  handleWenhaoSearch() {
    this.setState({
      showWenhaoCon: !this.state.showWenhaoCon,
    });
  }

  toggleDrawer(open) {
    this.setState({
      openCustom: !this.state.openCustom,
    });
  }

  toggleCustomerClose(open) {
    this.CustomReSetterClose();
  }

  toggleScopeDrawer(open) {
    this.setState({
      openCustom: open,
    });
  }

  handleSetKey(ev) {
    let key = ev.currentTarget.innerText;
    key = key.replace(/\n|\r/g, "");
    this.setState(
      {
        keyword: key,
        fileSearchType: 0,
        pageNum: 1,
        file_pageNum: 1,
        kb_pageNum: 1,
        fw_pageNum: 1,
        all_pageNum: 1,
      },
      () => {
        this.handleZdSearch(this.state.isInZd);
        // this.handleFileSearch();
        // this.handleKbSearch();
      }
    );
  }

  handlePageSize(ev) {
    this.setState(
      {
        pageSize: ev.target.value,
        pageNum: 1,
        file_pageNum: 1,
      },
      () => {
        this.handleSearch();
        this.handleFileSearch();
      }
    );
  }

  handleOrder(ev) {
    var parm = JSON.parse(JSON.stringify(this.state.reqparam)); // 深copy
    parm["order"] = ev.target.getAttribute("value");
    this.setState(
      {
        gjss: {
          sssz: this.state.gjss.sssz,
          sscwz: this.state.gjss.sscwz,
          category: this.state.gjss.category,
          fwValues: this.state.gjss.fwValues,
          sjfw: this.state.gjss.sjfw,
          sjfw_from: this.state.gjss.sjfw_from,
          sjfw_to: this.state.gjss.sjfw_to,
          order: ev.target.getAttribute("value"),
          zdfw: this.state.gjss.zdfw,
          pageSize: this.state.pageSize,
          fwOptions: this.state.gjss.fwOptions,
          categories: this.state.gjss.categories,
        },
        reqparam: parm,
      },
      () => {
        this.handleSearchJC();
      }
    );
  }

  CustomSetter(gjssform) {
    this.setState({
      gjss: gjssform,
    });
  }

  ZwgkSetter(zwgkform) {
    this.setState({
      zwgk: zwgkform,
    });
  }

  CustomReSetter() {
    this.setState({
      gjss: {
        sssz: defaultgjss.sssz,
        sscwz: defaultgjss.sscwz,
        category: defaultgjss.category,
        fwValues: defaultgjss.fwValues,
        sjfw: defaultgjss.sjfw,
        sjfw_from: defaultgjss.sjfw_from,
        sjfw_to: defaultgjss.sjfw_to,
        order: defaultgjss.order,
        zdfw: defaultgjss.zdfw,
        pageSize: defaultgjss.pageSize,
        fwOptions: this.state.gjss.fwOptions,
        categories: this.state.gjss.categories,
      },
    });
    this.setState({
      zwgk: {
        organization: defaultzwgk.organization,
        year: defaultzwgk.year,
        filenumberPre: defaultzwgk.filenumberPre,
        filenumber: defaultzwgk.filenumber,
        group: defaultzwgk.group,
        cwrq_from: defaultzwgk.cwrq_from,
        cwrq_to: defaultzwgk.cwrq_to,
        organizations: this.state.zwgk.organizations,
        years: this.state.zwgk.years,
        filenumbers: this.state.zwgk.filenumbers,
        groups: this.state.zwgk.groups,
      },
    });
  }

  CustomReSetterClose() {
    this.CustomReSetter();
    this.toggleScopeDrawer(false);
  }

  handleAllPaging(event, value) {
    var parm = JSON.parse(JSON.stringify(this.state.reqparam)); // 深copy
    parm["all_pageNum"] = value;

    this.setState(
      {
        all_pageNum: value,
        reqparam: parm,
      },
      () => this.handleAllSearch()
    );
  }

  handlePaging(event, value) {
    var parm = JSON.parse(JSON.stringify(this.state.reqparam)); // 深copy
    parm["pageNum"] = value;

    this.setState(
      {
        pageNum: value,
        reqparam: parm,
      },
      () => this.handleSearch()
    );
  }

  handleFilePaging(event, value) {
    var parm = JSON.parse(JSON.stringify(this.state.reqparam)); // 深copy
    parm["file_pageNum"] = value;

    this.setState(
      {
        file_pageNum: value,
        reqparam: parm,
      },
      () => this.handleFileSearch()
    );
  }

  handleKbPaging(event, value) {
    var parm = JSON.parse(JSON.stringify(this.state.reqparam)); // 深copy
    parm["kb_pageNum"] = value;

    this.setState(
      {
        kb_pageNum: value,
        reqparam: parm,
      },
      () => this.handleKbSearch()
    );
  }

  handleFwPaging(event, value) {
    var parm = JSON.parse(JSON.stringify(this.state.reqparam)); // 深copy
    parm["fw_pageNum"] = value;

    this.setState(
      {
        fw_pageNum: value,
        reqparam: parm,
      },
      () => this.handleFwSearch()
    );
  }

  setHotInfo(url, title) {
    const param = {
      url: url,
      title: title,
    };
    reqSetHotInfo(param, (res) => {
      // console.log(res);
    });
  }

  rendPageItem(item) {
    if (item === "next") {
      return "下一页";
    } else if (item === "previous") {
      return "上一页";
    } else if (item === "first") {
      return "首页";
    } else if (item === "last") {
      return "最后一页";
    }
  }

  handleBlurInput() {
    this.setState({
      showList: [],
    });
  }

  removeSearchHistory() {
    localStorage.clear();
  }

  handleCusSearchInput(value) {
    if (!value || value === "") {
      this.setState({
        cuskeyword: "",
      });
      return;
    }
    this.setState({
      cuskeyword: value,
    });
  }

  handleTabsChange = (ev, newValue) => {
    this.setState({
      tabValue: newValue,
    });
  };

  handleJiuCuo = (ev, newValue) => {
    var parm = JSON.parse(JSON.stringify(this.state.reqparam)); // 深copy
    parm["nojc"] = 1;
    this.setState(
      {
        nojc: 1,
        reqparam: parm,
      },
      () => {
        this.handleAllSearch();
        this.handleSearch();
        this.handleFileSearch();
        this.handleKbSearch();
        this.handleFwSearch();
      }
    );
  };

  handleIsInZd = (ev) => {
    if (ZQ_WEBSITE_IDS.includes(this.state.websiteid)) {
      this.setState({
        isInZd: !this.state.isInZd,
      });
    }
  };

  handleSearchType(ev) {
    let searchType = ev.target.getAttribute("value");
    this.setState({
      searchType: searchType,
      tabValue: searchType === "1" ? 2 : 0,
    });
  }

  render() {
    const { classes } = this.props;

    var _this = this;
    var _state = this.state;
    let suggestIndex = 10;
    const Li = _state.showList.map((value, index) => {
      if (value === "推荐阅读") {
        suggestIndex = index;
      }
      return (
        <li
          key={index}
          data-index={index}
          className={
            index >= suggestIndex
              ? "is-suggest"
              : this.state.listIndex === index
              ? "is-select"
              : ""
          }
          onMouseOver={
            index !== suggestIndex ? this.handleMouseSelect.bind(_this) : null
          }
          onClick={
            index !== suggestIndex ? this.handleSelectClick.bind(_this) : null
          }
          // dangerouslySetInnerHTML={{ __html: value }}
        >
          {index > suggestIndex ? (
            <span
              className="right-number-class"
              style={
                index - suggestIndex === 1
                  ? { backgroundColor: "#fe2d46" }
                  : index - suggestIndex === 2
                  ? { backgroundColor: "#f60" }
                  : index - suggestIndex === 3
                  ? { backgroundColor: "#faa90e" }
                  : { backgroundColor: "#9195a3" }
              }
            >
              {index - suggestIndex}
            </span>
          ) : (
            ""
          )}
          <span dangerouslySetInnerHTML={{ __html: value }}></span>
        </li>
      );
    });

    let searchBottom =
      _state.hotWords.length > 0
        ? _state.hotWords.map((value, index) => (
            <Link href="javascript:;" onClick={this.handleSetKey.bind(this)}>
              {value.keyword}
            </Link>
          ))
        : "";

    let hoturls =
      _state.hotInfos.length > 0
        ? _state.hotInfos.map((value, index) =>
            index < 5 ? (
              <ListItem
                button
                target="_blank"
                style={{ height: "40px" }}
                component="a"
                href={value.url}
              >
                <span
                  className="right-number-class"
                  style={
                    index === 0
                      ? { backgroundColor: "#fe2d46" }
                      : index === 1
                      ? { backgroundColor: "#f60" }
                      : index === 2
                      ? { backgroundColor: "#faa90e" }
                      : { backgroundColor: "#9195a3" }
                  }
                >
                  {index + 1}
                </span>
                &ensp;
                <ListItemText className="textText" primary={value.title} />
              </ListItem>
            ) : (
              ""
            )
          )
        : "";

    let localhistory = [];
    localhistory = JSON.parse(localStorage.getItem("searchHistory"));
    let lhistory = [];
    let random = Math.floor(Math.random() * 3) + 1;
    if (localhistory && localhistory.length > 0) {
      lhistory = localhistory.map((value, index) =>
        index < 10 ? (
          <Chip
            label={decodeURIComponent(encodePacent(value))}
            color="primary"
            onClick={this.handleSetKey.bind(this)}
            component="a"
            href="#chip"
            clickable
            className="chip-class"
            style={
              index % 3 === 0
                ? {
                    backgroundColor: "rgba( 240, 240, 240, 0.8)",
                    color: "rgba(70, 69, 69, 0.6)",
                  }
                : index % 3 === 1
                ? { backgroundColor: "rgba( 231, 168, 59, 0.8)" }
                : {
                    backgroundColor: "rgba( 231, 218, 129, 0.8)",
                    color: "rgba(70, 69, 69, 0.6)",
                  }
            }
          />
        ) : (
          ""
        )
      );
    }
    lhistory.push(
      <a
        class="clear-history"
        href="javascript:void(0);"
        onClick={this.removeSearchHistory.bind(this)}
      >
        清除所有搜索历史
      </a>
    );

    const rightInfo = (
      <Grid container className="right-info" spacing={1}>
        <Grid
          style={{
            height: "50px",
            borderBottom: "1px solid #d1d1d1",
            marginTop: "-12px",
          }}
          item
          xs={8}
        >
          <p className="history-p">最近搜索</p>
        </Grid>
        <Grid item xs={12}>
          <Paper
            className={classes.paper}
            elevation={0}
            style={{ height: "500px", marginRight: "10px" }}
          >
            <div>
              <Paper elevation={0} style={{ font: "12px" }}>
                {lhistory}
                <br />
                <p className="history-p-zixun">热搜资讯</p>
                <List
                  style={{
                    marginLeft: "10px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {hoturls}
                </List>
              </Paper>
            </div>
          </Paper>
        </Grid>
      </Grid>
    );

    var tabs = ZQ_WEBSITE_IDS.includes(this.state.websiteid) ? (
      <Tabs
        className="tabs-class"
        value={this.state.tabValue}
        onChange={this.handleTabsChange.bind(this)}
        indicatorColor="primary"
        textColor="primary"
        aria-label="tabs"
      >
        <Tab
          style={{ fontSize: this.state.isGh ? 24 : 12 }}
          label="全部"
          icon={<Home style={{ fontSize: this.state.isGh ? 36 : 18 }} />}
          {...a11yProps(0)}
        />
        <Tab
          style={{ fontSize: this.state.isGh ? 24 : 12 }}
          label="新闻动态"
          icon={
            <Announcement style={{ fontSize: this.state.isGh ? 36 : 18 }} />
          }
          {...a11yProps(1)}
        />
        <Tab
          style={{ fontSize: this.state.isGh ? 24 : 12 }}
          label="政策文件"
          icon={<FileCopy style={{ fontSize: this.state.isGh ? 36 : 18 }} />}
          {...a11yProps(2)}
        />
        <Tab
          style={{ fontSize: this.state.isGh ? 24 : 12 }}
          label="政民互动"
          icon={<LiveHelp style={{ fontSize: this.state.isGh ? 36 : 18 }} />}
          {...a11yProps(3)}
        />
        <Tab
          style={{ fontSize: this.state.isGh ? 24 : 12 }}
          label="办事服务"
          icon={<HeadsetMic style={{ fontSize: this.state.isGh ? 36 : 18 }} />}
          {...a11yProps(4)}
        />
      </Tabs>
    ) : (
      <Tabs
        className="tabs-class"
        value={this.state.tabValue}
        onChange={this.handleTabsChange.bind(this)}
        indicatorColor="primary"
        textColor="primary"
        aria-label="tabs"
      >
        <Tab
          style={{ fontSize: this.state.isGh ? 24 : 12 }}
          label="新闻动态"
          icon={
            <Announcement style={{ fontSize: this.state.isGh ? 36 : 18 }} />
          }
          value={1}
          {...a11yProps(1)}
        />
        <Tab
          style={{ fontSize: this.state.isGh ? 24 : 12 }}
          label="政策文件"
          icon={<FileCopy style={{ fontSize: this.state.isGh ? 36 : 18 }} />}
          value={2}
          {...a11yProps(2)}
        />
      </Tabs>
    );
    return (
      <div>
        <div
          className="search clearfix"
          ergodic="serve"
          barrierfree_zone_dsc="当前为服务区，有检索功能"
        >
          <div
            className="searchChose bt-left"
            onClick={this.handleIsInZd.bind(this)}
          >
            {_state.isInZd ? "本站" : "站群"}
          </div>
          <input
            type="text"
            className="intTxt bt-left"
            style={{ outline: "none" }}
            onFocus={this.handleInput.bind(_this)}
            onChange={this.handleInput.bind(_this)}
            onKeyDown={this.handleKeyEnter.bind(_this)}
            ref="input"
            placeholder="请输入您想了解的政策/资讯/服务"
            value={decodeURIComponent(encodePacent(this.state.keyword))}
          />
          <button
            className="inputBtn bt-left"
            style={{ outline: "none", cursor: "pointer" }}
            onClick={this.handleZdSearch.bind(this)}
          >
            搜索
          </button>
          {/*<div className="backhome-location">*/}
          {/*  <PinDrop*/}
          {/*    style={{ color: "#e7a83b", height: "40px", width: "40px" }}*/}
          {/*  />*/}
          {/*  <Link*/}
          {/*    href="#"*/}
          {/*    className="backhome-location-a"*/}
          {/*    onClick={() => {*/}
          {/*      window.location.href =*/}
          {/*        "http://" + getLocations(this.state.websiteid).url;*/}
          {/*    }}*/}
          {/*  >*/}
          {/*    当前站点：*/}
          {/*    <br />*/}
          {/*    {getLocations(this.state.websiteid).name}*/}
          {/*  </Link>*/}
          {/*</div>*/}
          {/* <Link
            href="javascript:;"
            className="backhome"
            onClick={() => {
              window.location.href = "http://www.taizhou.gov.cn/";
            }}
          >
            返回首页
          </Link> */}
          {Li.length > 0 ? (
            <div className="search-result-list">
              <ul>{Li}</ul>
            </div>
          ) : (
            ""
          )}
          <div
            // onClick={() => this.handleWenhaoSearch()}
            className="search-result-wenhao"
          ></div>
        </div>

        {/*<div className="hotSearch clearfix">*/}
        {/*  <div>*/}
        {/*    <span>热门搜索：</span>*/}
        {/*    {searchBottom}*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="searchType clearfix">
          <RadioGroup
            row
            style={{ position: "absolute" }}
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="radio-group"
            value={_state.searchType}
            onChange={this.handleSearchType.bind(this)}
          >
            <FormLabel
              classes={{
                root: "custom_form_label_root",
              }}
            >
              搜索方式：
            </FormLabel>
            <FormControlLabel
              value="0"
              control={<Radio size="small" color="primary" />}
              label="默认"
              classes={{
                root: "custom_form_label_root",
              }}
            />
            <FormControlLabel
              value="1"
              control={<Radio size="small" color="primary" />}
              label="文件搜索"
              classes={{
                root: "custom_form_label_root",
              }}
            />
            <FormControlLabel
              value="2"
              control={<Radio size="small" color="primary" />}
              label="精准搜索"
              classes={{
                root: "custom_form_label_root",
              }}
            />
          </RadioGroup>
        </div>
        <Collapse
          className="under-top-search-button"
          in={this.state.searchType === "1"}
        >
          <Paper>
            <SearchDialogFiles
              CustomSetter={this.CustomSetter.bind(this)}
              ZwgkSetter={this.ZwgkSetter.bind(this)}
              CustomReSetter={this.CustomReSetter.bind(this)}
              initData={this.state.gjss}
              xxgkData={this.state.zwgk}
              handleClose={() => this.toggleDrawer(false)}
              handleCusSearchInput={this.handleCusSearchInput.bind(this)}
              cuskeyword={this.state.cuskeyword}
              handleSearchClick={this.handleSearchClick.bind(this)}
              isTop={true}
            />
          </Paper>
        </Collapse>
        <Collapse
          className="under-top-search-button"
          in={this.state.searchType === "2"}
        >
          <Paper>
            <SearchDialog
              CustomSetter={this.CustomSetter.bind(this)}
              ZwgkSetter={this.ZwgkSetter.bind(this)}
              CustomReSetter={this.CustomReSetter.bind(this)}
              initData={this.state.gjss}
              xxgkData={this.state.zwgk}
              handleClose={() => this.toggleDrawer(false)}
              handleCusSearchInput={this.handleCusSearchInput.bind(this)}
              cuskeyword={this.state.cuskeyword}
              handleSearchClick={this.handleSearchClick.bind(this)}
              isTop={true}
            />
          </Paper>
        </Collapse>

        {this.state.showContent ? (
          <div className="content-body">
            <Paper className="home-paper">
              <div
                ergodic="navigation"
                barrierfree_zone_dsc="导航区，当前为主导航区，有全部、新闻动态、政策文件、政民互动、办事服务等栏目"
              >
                {tabs}
              </div>
              <Grid container spacing={1}>
                <Grid className="right-display" item xs={12}>
                  <Collapse in={this.state.openCustom}>
                    <Divider />
                    <SearchDialog
                      CustomSetter={this.CustomSetter.bind(this)}
                      ZwgkSetter={this.ZwgkSetter.bind(this)}
                      CustomReSetter={this.CustomReSetter.bind(this)}
                      initData={this.state.gjss}
                      xxgkData={this.state.zwgk}
                      handleClose={() => this.toggleDrawer(false)}
                      handleCusSearchInput={this.handleCusSearchInput.bind(
                        this
                      )}
                      cuskeyword={this.state.cuskeyword}
                      handleSearchClick={this.handleSearchClick.bind(this)}
                    />
                  </Collapse>
                </Grid>
                {this.state.tabValue === 0 ? (
                  <Grid container spacing={1}>
                    <SearchTool
                      order={_state.gjss.order}
                      totalCount={_state.all_totalcount}
                      handleOrder={this.handleOrder.bind(this)}
                      showLoading={_state.all_showLoading}
                      nojc={_state.nojc}
                      originalKeyword={_state.originalKeyword}
                      correctedKeyword={_state.correctedKeyword}
                      handleJiuCuo={this.handleJiuCuo.bind(this)}
                      isGh={_state.isGh}
                    />
                    <Grid item xs={8}>
                      <Paper className="content-class" elevation={0}>
                        <SearchAll
                          isMobile={_state.isMobile}
                          pageNum={_state.all_pageNum}
                          handlePaging={this.handleAllPaging.bind(this)}
                          handleTabsChange={this.handleTabsChange.bind(this)}
                          pages={_state.all_pages}
                          results={_state.allResult}
                          fwJuhe={_state.fw_juhe}
                          juheResult1={_state.xw_juhe}
                          juheResult2={_state.hd_juhe}
                          showLoading={_state.all_showLoading}
                          setHotInfo={this.setHotInfo.bind(this)}
                          isGh={_state.isGh}
                          nojc={_state.nojc}
                          originalKeyword={_state.originalKeyword}
                          correctedKeyword={_state.correctedKeyword}
                        />
                      </Paper>
                    </Grid>
                    <Grid className="right-display history-right" item xs={4}>
                      {rightInfo}
                    </Grid>
                  </Grid>
                ) : this.state.tabValue === 1 ? (
                  <Grid container spacing={1}>
                    <SearchTool
                      order={_state.gjss.order}
                      totalCount={_state.totalcount}
                      handleOrder={this.handleOrder.bind(this)}
                      showLoading={_state.showLoading}
                      nojc={_state.nojc}
                      originalKeyword={_state.originalKeyword}
                      correctedKeyword={_state.correctedKeyword}
                      handleJiuCuo={this.handleJiuCuo.bind(this)}
                    />
                    <Grid item xs={8}>
                      <Paper className="content-class" elevation={0}>
                        {/* <div className="content-class">{contents}</div> */}
                        <SearchNews
                          isMobile={_state.isMobile}
                          pageNum={_state.pageNum}
                          handlePaging={this.handlePaging.bind(this)}
                          pages={_state.pages}
                          results={_state.results}
                          showLoading={_state.showLoading}
                          setHotInfo={this.setHotInfo.bind(this)}
                        />
                      </Paper>
                    </Grid>
                    <Grid className="right-display history-right" item xs={4}>
                      <SearchDialog
                        CustomSetter={this.CustomSetter.bind(this)}
                        ZwgkSetter={this.ZwgkSetter.bind(this)}
                        CustomReSetter={this.CustomReSetter.bind(this)}
                        initData={this.state.gjss}
                        xxgkData={this.state.zwgk}
                        handleClose={() => this.toggleDrawer(false)}
                        handleCusSearchInput={this.handleCusSearchInput.bind(
                          this
                        )}
                        cuskeyword={this.state.cuskeyword}
                        handleSearchClick={this.handleSearchClick.bind(this)}
                      />
                      {rightInfo}
                    </Grid>
                  </Grid>
                ) : this.state.tabValue === 2 ? (
                  <Grid container spacing={1}>
                    <SearchTool
                      order={_state.gjss.order}
                      totalCount={_state.file_totalcount}
                      handleOrder={this.handleOrder.bind(this)}
                      showLoading={_state.file_showLoading}
                      nojc={_state.nojc}
                      originalKeyword={_state.originalKeyword}
                      correctedKeyword={_state.correctedKeyword}
                      handleJiuCuo={this.handleJiuCuo.bind(this)}
                    />
                    <Grid item xs={8}>
                      <Paper
                        id="fileAnchor"
                        className="file-class"
                        elevation={0}
                      >
                        {/* <div className="content-class">{contents}</div> */}
                        <SearchFiles
                          isMobile={_state.isMobile}
                          pageNum={_state.file_pageNum}
                          handlePaging={this.handleFilePaging.bind(this)}
                          pages={_state.file_pages}
                          results={_state.file_results}
                          showLoading={_state.file_showLoading}
                          setHotInfo={this.setHotInfo.bind(this)}
                        />
                      </Paper>
                    </Grid>
                    <Grid className="right-display history-right" item xs={4}>
                      <SearchDialog
                        CustomSetter={this.CustomSetter.bind(this)}
                        ZwgkSetter={this.ZwgkSetter.bind(this)}
                        CustomReSetter={this.CustomReSetter.bind(this)}
                        initData={this.state.gjss}
                        xxgkData={this.state.zwgk}
                        handleClose={() => this.toggleDrawer(false)}
                        handleCusSearchInput={this.handleCusSearchInput.bind(
                          this
                        )}
                        cuskeyword={this.state.cuskeyword}
                        handleSearchClick={this.handleSearchClick.bind(this)}
                      />
                      <SearchDialogFiles
                        CustomSetter={this.CustomSetter.bind(this)}
                        ZwgkSetter={this.ZwgkSetter.bind(this)}
                        CustomReSetter={this.CustomReSetter.bind(this)}
                        initData={this.state.gjss}
                        xxgkData={this.state.zwgk}
                        handleClose={() => this.toggleDrawer(false)}
                        handleCusSearchInput={this.handleCusSearchInput.bind(
                          this
                        )}
                        cuskeyword={this.state.cuskeyword}
                        handleSearchClick={this.handleSearchClick.bind(this)}
                      />
                      {rightInfo}
                    </Grid>
                  </Grid>
                ) : this.state.tabValue === 3 ? (
                  <Grid container spacing={1}>
                    <SearchTool
                      order={_state.gjss.order}
                      totalCount={_state.kb_totalcount}
                      handleOrder={this.handleOrder.bind(this)}
                      showLoading={_state.kb_showLoading}
                      nojc={_state.nojc}
                      originalKeyword={_state.originalKeyword}
                      correctedKeyword={_state.correctedKeyword}
                      handleJiuCuo={this.handleJiuCuo.bind(this)}
                    />
                    <Grid item xs={8}>
                      <Paper className="content-class" elevation={0}>
                        <SearchKb
                          isMobile={_state.isMobile}
                          pageNum={_state.kb_pageNum}
                          handlePaging={this.handleKbPaging.bind(this)}
                          pages={_state.kb_pages}
                          results={_state.kb_results}
                          showLoading={_state.kb_showLoading}
                          setHotInfo={this.setHotInfo.bind(this)}
                        />
                      </Paper>
                    </Grid>
                    <Grid className="right-display history-right" item xs={4}>
                      <SearchDialog
                        flag="kb"
                        CustomSetter={this.CustomSetter.bind(this)}
                        ZwgkSetter={this.ZwgkSetter.bind(this)}
                        CustomReSetter={this.CustomReSetter.bind(this)}
                        initData={this.state.gjss}
                        xxgkData={this.state.zwgk}
                        handleClose={() => this.toggleDrawer(false)}
                        handleCusSearchInput={this.handleCusSearchInput.bind(
                          this
                        )}
                        cuskeyword={this.state.cuskeyword}
                        handleSearchClick={this.handleSearchClick.bind(this)}
                      />
                      {rightInfo}
                    </Grid>
                  </Grid>
                ) : this.state.tabValue === 4 ? (
                  <Grid container spacing={1}>
                    <SearchTool
                      order={_state.gjss.order}
                      totalCount={_state.fw_totalcount}
                      handleOrder={this.handleOrder.bind(this)}
                      showLoading={_state.fw_showLoading}
                      nojc={_state.nojc}
                      originalKeyword={_state.originalKeyword}
                      correctedKeyword={_state.correctedKeyword}
                      handleJiuCuo={this.handleJiuCuo.bind(this)}
                    />
                    <Grid item xs={8}>
                      <Paper className="content-class" elevation={0}>
                        <SearchService
                          isMobile={_state.isMobile}
                          pageNum={_state.fw_pageNum}
                          handlePaging={this.handleFwPaging.bind(this)}
                          pages={_state.fw_pages}
                          results={_state.fw_results}
                          showLoading={_state.fw_showLoading}
                          setHotInfo={this.setHotInfo.bind(this)}
                        />
                      </Paper>
                    </Grid>
                    <Grid className="right-display history-right" item xs={4}>
                      <SearchDialog
                        CustomSetter={this.CustomSetter.bind(this)}
                        ZwgkSetter={this.ZwgkSetter.bind(this)}
                        CustomReSetter={this.CustomReSetter.bind(this)}
                        initData={this.state.gjss}
                        xxgkData={this.state.zwgk}
                        handleClose={() => this.toggleDrawer(false)}
                        handleCusSearchInput={this.handleCusSearchInput.bind(
                          this
                        )}
                        cuskeyword={this.state.cuskeyword}
                        handleSearchClick={this.handleSearchClick.bind(this)}
                      />
                      {rightInfo}
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
            </Paper>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default withSnackbar(withStyles(useStyles)(SearchResult));
